import { isEmpty } from 'ramda';

import { EDIT_EXERCISE_FROM_ARCHIVE, EDIT_EXERCISE_FROM_DRAFT, EDIT_EXERCISE_FROM_EDITORIAL, EDIT_EXERCISE_FROM_SEARCH } from '../actions/exercise';
import * as types from '../constants/ActionTypes';

export const initialState = {
    editExercise: {
        archive: false,
        draft: true,
        editorial: false,
        search: false
    },
    exercises: [],
    exercisesCount: 0,
    exercisesShowFavouriteToggle: false,
    contentTaxonomy: [],
    searchIdList: [],
    errorMsg: '',
    loaded: true,
    loadedContentTaxonomy: true,
    errorType: '',
    searchPage: 1,
    loading: false,
    filters: {
        books: [],
        authors: [],
        subjects: [],
        itemTypes: [],
        favouriteOnly: false
    },
    searchTerm: '',
    isSaving: false,
    isUpdating: false,
    isDeleting: false,
    isSuggestionSelected: false,
    userExercises: [],
    userExercisesCount: 0,
    userExercisePage: 1,
    userExerciseFilters: {
        favouriteOnly: false
    }
};

export default function Exercise(state = initialState, action = {}) {
    switch (action.type) {
        case types.UPDATE_EXERCISE: {
            return {
                ...state,
                isUpdating: true,
                fetchId: action.exerciseId
            };
        }
        case types.SAVE_EXERCISE: {
            return {
                ...state,
                isSaving: true,
                fetchId: action.exerciseId
            };
        }
        case types.UPDATE_EXERCISE_SUCCESS: {
            return {
                ...state,
                isUpdating: false,
                fetchId: action.exerciseId
            };
        }
        case types.SAVE_EXERCISE_SUCCESS: {
            return {
                ...state,
                isSaving: false,
                fetchId: action.exerciseId
            };
        }
        case types.UPDATE_EXERCISE_FAILURE: {
            return {
                ...state,
                isUpdating: false,
                fetchId: action.exerciseId
            };
        }
        case types.SAVE_EXERCISE_FAILURE: {
            return {
                ...state,
                isSaving: false,
                fetchId: action.exerciseId
            };
        }
        case types.FETCH_EXERCISE: {
            return {
                ...state,
                loaded: false,
                errorMsg: '',
                errorType: '',
                loading: true,
                fetchId: action.exerciseId
            };
        }
        case types.FETCH_EXERCISE_FAILURE: {
            return {
                ...state,
                errorMsg: "Siamo spiacenti, ma per problemi tecnici in questo momento non è possibile ottenere l'esercizio. Si prega di riprovare più tardi.",
                loaded: true,
                loading: false,
                errorType: 'RM_FAILURE',
                error: action.error
            };
        }
        case types.FETCH_EXERCISE_SUCCESS: {
            if (action.result && !isEmpty(action.result)) {
                return {
                    ...state,
                    errorMsg: '',
                    errorType: '',
                    exercise: action.result,
                    loaded: true,
                    loading: false
                };
            }
            return {
                ...state,
                errorMsg: "Siamo spiacenti, è stato impossibile trovare l' esercizio richiesto.",
                errorType: 'NOT_FOUND',
                exercise: undefined,
                loaded: true,
                loading: false
            };
        }
        case types.SEARCH_EXERCISES: {
            return {
                ...state,
                loaded: false,
                errorMsg: '',
                errorType: '',
                exercises: [],
                exercisesCount: 0,
                searchPage: 1,
                loading: true,
                searchIdList: action.idList,
                filters: action.filters,
                searchTerm: action.searchTerm,
                isSuggestionSelected: action.isSuggestionSelected
            };
        }
        case types.SEARCH_EXERCISES_SUCCESS: {
            if (action.result.length < 1) {
                return {
                    ...state,
                    errorMsg: 'La ricerca non ha prodotto alcun risultato.',
                    exercises: action.result,
                    exercisesCount: action.totalCount,
                    exercisesShowFavouriteToggle: !!action.favourites,
                    loaded: true,
                    loading: false,
                    errorType: ''
                };
            }
            return {
                ...state,
                errorMsg: '',
                exercises: action.result,
                exercisesCount: action.totalCount,
                exercisesShowFavouriteToggle: true,
                loaded: true,
                loading: false,
                errorType: ''
            };
        }
        case types.SEARCH_EXERCISES_FAILURE: {
            return {
                ...state,
                errorMsg:
                    'Siamo spiacenti, ma per problemi tecnici in questo momento non è possibile ricercare esercizi Zanichelli. Si prega di riprovare più tardi o con altre chiavi.',
                exercisesShowFavouriteToggle: false,
                loaded: true,
                loading: false,
                errorType: 'CAT_FAILURE'
            };
        }
        case types.SEARCH_MORE_EXERCISES: {
            return {
                ...state,
                loaded: false,
                errorMsg: '',
                errorType: '',
                loading: true
            };
        }
        case types.SEARCH_MORE_EXERCISES_SUCCESS: {
            return {
                ...state,
                exercises: state.exercises.concat(action.result),
                exercisesShowFavouriteToggle: true,
                loaded: true,
                errorMsg: '',
                errorType: '',
                searchPage: action.searchPage,
                loading: false
            };
        }
        case types.SEARCH_MORE_EXERCISES_FAILURE: {
            return {
                ...state,
                loaded: true,
                errorMsg:
                    'Siamo spiacenti, ma per problemi tecnici in questo momento non è possibile ricercare esercizi Zanichelli. Si prega di riprovare più tardi o con altre chiavi.',
                errorType: 'CAT_FAILURE',
                exercisesShowFavouriteToggle: false,
                loading: false
            };
        }
        case types.GET_USER_EXERCISES:
            return {
                ...state,
                loaded: false,
                userExercisePage: 1,
                userExercises: [],
                userExercisesCount: 0,
                userExerciseFilters: action.filters
            };
        case types.GET_USER_EXERCISES_SUCCESS:
            return {
                ...state,
                userExercises: action.result,
                userExercisesCount: action.totalCount,
                loaded: true
            };
        case types.GET_MORE_USER_EXERCISES:
            return {
                ...state,
                loaded: false,
                userExercisePage: 1
            };
        case types.GET_MORE_USER_EXERCISES_SUCCESS:
            return {
                ...state,
                userExercises: state.userExercises.concat(action.result),
                loaded: true,
                userExercisePage: action.userExercisePage
            };
        case types.GET_MORE_USER_EXERCISES_FAILURE:
            return {
                ...state,
                loaded: true
            };
        case types.GET_USER_EXERCISES_FAILURE:
            return {
                ...state,
                loaded: true
            };
        case types.GET_CONTENT_TAXONOMY: {
            return {
                ...state,
                loadedContentTaxonomy: false,
                errorMsg: '',
                errorType: ''
            };
        }
        case types.GET_CONTENT_TAXONOMY_SUCCESS: {
            if (action.result && !isEmpty(action.result)) {
                return {
                    ...state,
                    contentTaxonomy: action.result,
                    loadedContentTaxonomy: true,
                    errorMsg: '',
                    errorType: ''
                };
            }
            return {
                ...state,
                loadedContentTaxonomy: true,
                errorMsg: 'La ricerca non ha prodotto alcun risultato.',
                errorType: ''
            };
        }
        case types.GET_CONTENT_TAXONOMY_FAILURE: {
            return {
                ...state,
                loadedContentTaxonomy: true,
                errorMsg:
                    'Siamo spiacenti, ma per problemi tecnici in questo momento non è possibile ricercare esercizi Zanichelli. Si prega di riprovare più tardi.',
                errorType: 'ZNS_FAILURE'
            };
        }
        case types.RESET_SEARCH: {
            return {
                ...state,
                exercises: [],
                searchIdList: [],
                filters: initialState.filters
            };
        }
        case types.UPDATE_LOCATION: {
            return {
                ...state,
                exercises: [],
                searchIdList: [],
                filters: initialState.filters
            };
        }
        case types.RESET_EXERCISES: {
            return {
                ...state,
                exercises: [],
                searchIdList: [],
                filters: initialState.filters
            };
        }
        case EDIT_EXERCISE_FROM_ARCHIVE: {
            return {
                ...state,
                editExercise: {
                    archive: true,
                    draft: false,
                    editorial: false,
                    search: false
                },
                loaded: false,
                exercise: undefined
            };
        }
        case EDIT_EXERCISE_FROM_DRAFT: {
            return {
                ...state,
                editExercise: {
                    archive: false,
                    draft: true,
                    editorial: false,
                    search: false
                },
                errorMsg: '',
                errorType: '',
                exercise: undefined,
                loaded: true,
                loading: false
            };
        }
        case EDIT_EXERCISE_FROM_EDITORIAL: {
            return {
                ...state,
                editExercise: {
                    archive: false,
                    draft: false,
                    editorial: true,
                    search: false
                },
                loaded: false,
                exercise: undefined
            };
        }
        case EDIT_EXERCISE_FROM_SEARCH: {
            return {
                ...state,
                editExercise: {
                    archive: false,
                    draft: false,
                    editorial: false,
                    search: true
                },
                loaded: false,
                exercise: undefined
            };
        }
        case types.DELETE_EXERCISE:
            return {
                ...state,
                isDeleting: true
            };
        case types.DELETE_EXERCISE_SUCCESS:
            return {
                ...state,
                isDeleting: false,
                userExercises: []
            };
        case types.DELETE_EXERCISE_FAILURE:
            return {
                ...state,
                isDeleting: false
            };
        case types.EXERCISES_EDITORIAL_FILTERS_CHANGE:
            const searchIdList = action.searchIdList ? action.searchIdList : state.searchIdList;
            const searchTerm = action.searchTerm ? action.searchTerm : action.filters.subjects ? '' : state.searchTerm;
            return {
                ...state,
                searchIdList,
                searchTerm,
                filters: {
                    ...state.filters,
                    ...action.filters
                }
            };
        default:
            return state;
    }
}
